export const stepItems = [
  { title: "Contact Information" },
  { title: "Billing Information" },
  { title: "Payment & Terms" },
  { title: "Confirmation" },
];

